import React from "react"
import { MenuItem, TextField } from "@mui/material"

import { LessonTypeName } from "../../types"

type Props = {
  selectedLessonType: LessonTypeName | "all"
  onSelected: (lessonType: LessonTypeName) => void
  doIncludeAllOption?: boolean
  isDisabled?: boolean
  acceptedTypes?: LessonTypeName[]
}

const LessonTypeSelect = ({
  selectedLessonType,
  onSelected,
  doIncludeAllOption = false,
  isDisabled = false,
  acceptedTypes,
}: Props) => (
  <TextField
    select
    name="lessonType"
    label="Lesson Type"
    value={selectedLessonType}
    onChange={(e) => onSelected(e.target.value as LessonTypeName)}
    margin="normal"
    data-cy="lesson-type-select"
    fullWidth
    disabled={isDisabled}
  >
    {doIncludeAllOption && (
      <MenuItem value="all" key="all">
        All
      </MenuItem>
    )}
    {(acceptedTypes || Object.values(LessonTypeName)).map((lt) => (
      <MenuItem value={lt} key={lt} data-cy="lesson-type-select-item">
        {lt}
      </MenuItem>
    ))}
  </TextField>
)

export default LessonTypeSelect
